module.exports = __webpack_public_path__ + "static/media/creative-woman.5a496ea3.svg";